import Layout from "../components/Layout";

const FourOhFour = () => {
  return <Layout>
    <section>

        <p>FourOhFour</p>
    </section>
    </Layout>
}

export default FourOhFour;